import {useLegacyGrpcRequestCallback} from '@aboutyou/data-fetcher';
import {OrdersService_DownloadDocumentLazy} from '@aboutyou/grpc-clients/grips/protos/orders/v1/orders_service.grpc.lazy';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  UnstyledButton,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {useCustomerSession} from '@aboutyou/user';
import {styled} from '@linaria/react';
import React from 'react';

interface OrderDetailInvoice {
  displayName: string;
  typeLabel: string;
  url: string;
}

export const DownloadInvoiceModalBody = ({
  invoices,
}: {
  invoices: OrderDetailInvoice[];
}) => {
  const getDocument = useLegacyGrpcRequestCallback(
    OrdersService_DownloadDocumentLazy,
  );
  const customerSession = useCustomerSession();

  const getDownloadInvoice = (url: string) => {
    getDocument
      .mutateAsync({url, customerSession: customerSession!})
      .then(data => {
        const blob = new Blob([data.document], {type: 'application/pdf'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = data.fileName;
        document.body.appendChild(a);
        a.click();

        // cleanup
        a.remove();
      });
  };

  return (
    <InvoiceModalBodyWrapper>
      {invoices.map(invoice => {
        return (
          <InvoiceModalItemWrapper key={invoice.displayName}>
            <InvoiceModalTitleWrapper>
              <span>{invoice.typeLabel}</span>
              <span>{invoice.displayName}</span>
            </InvoiceModalTitleWrapper>
            <UnstyledButton
              onClick={() => getDownloadInvoice(invoice.url)}
              aria-label={undefined}
            >
              <Icon asset={GenericIconName.Download} size="S" />
            </UnstyledButton>
          </InvoiceModalItemWrapper>
        );
      })}
    </InvoiceModalBodyWrapper>
  );
};

const InvoiceModalBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const InvoiceModalTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 20px;

  span:first-child {
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.mediumHeavy};
    text-transform: uppercase;
    line-height: 18px;
    letter-spacing: 0.48px;
  }
`;

const InvoiceModalItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;

  ${tabletAndUpLinaria(`
    padding-bottom: 20px;
  `)}

  &:not(:last-child) {
    border-bottom: 1px solid ${COLORS.Grey4};
  }

  &:last-child {
    padding-bottom: 0;
  }
`;
